import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
// import moment from 'moment';
import { resetGuestRsvp, getPublicRsvpPageV2 } from '../../../actions/PublicWebsiteActions';
import { resetEntities } from '../../../actions/website/EntityActions';
import GuestLookupForm from './rsvp/GuestLookupForm';
import GuestRsvpForm from './rsvp/GuestRsvpForm';
// import SinglePageRsvpForm from './rsvp/SinglePageRsvpForm';
// import MultiPageRsvpForm from './rsvp/MultiPageRsvpForm';
// import FeatureFlags from '../../../util/featureFlags';

class Rsvp extends Component {
  componentDidMount() {
    const { getRsvpEntities, forPreview } = this.props;
    if (!forPreview) {
      getRsvpEntities();
    }
  }

  componentWillUnmount() {
    const { unloadEntities, forPreview } = this.props;
    if (!forPreview) {
      unloadEntities();
    }
  }

  render() {
    const { page, forPreview, guestGroupRsvp, busy, wedding } = this.props;
    return (
      <div id="rsvp-page-v2" className="container">
        {page && !busy && (
          <div>
            {!forPreview && !guestGroupRsvp.guest_group_id && !guestGroupRsvp.success && (
              <GuestLookupForm wedding={wedding} />
            )}
            {(forPreview || guestGroupRsvp.guest_group_id) && (
              <GuestRsvpForm forPreview={forPreview} page={page} />
            )}
          </div>
        )}
      </div>
    );
  }
}

Rsvp.propTypes = {
  getRsvpEntities: PropTypes.func.isRequired,
  unloadEntities: PropTypes.func.isRequired,
  forPreview: PropTypes.bool,
  page: PropTypes.shape({
    title: PropTypes.string,
    header_image_url: PropTypes.string,
  }).isRequired,
  guestGroupRsvp: PropTypes.oneOfType([
    PropTypes.shape({}),
    PropTypes.arrayOf(PropTypes.shape({})),
  ]),
  busy: PropTypes.bool,
  wedding: PropTypes.shape({
    owner_first_name: PropTypes.string,
    owner_last_name: PropTypes.string,
    partner_first_name: PropTypes.string,
    partner_last_name: PropTypes.string,
  }),
};

const mapStateToProps = (state, ownProps) => ({
  wedding: ownProps.forPreview ? state.wedding.wedding : state.publicWebsite.wedding,
  orderedIds: ownProps.forPreview ? state.website.entities.orderedIds : null,
  page: ownProps.forPreview ? ownProps.page : state.publicWebsite.page,
  guestGroupRsvp: ownProps.forPreview ? {} : state.publicWebsite.guestGroupRsvp,
  busy: state.publicWebsite.busy,
});

const mapDispatchToProps = dispatch => ({
  getRsvpEntities: () => dispatch(getPublicRsvpPageV2()),
  unloadEntities: () => dispatch(resetEntities()),
  resetGuestGroup: () => dispatch(resetGuestRsvp()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Rsvp);



// WEBPACK FOOTER //
// ./src/components/PublicWebsite/pages/Rsvp.jsx